var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.167 3.333a5.833 5.833 0 1 0 4.047 10.035.866.866 0 0 1 .154-.154 5.833 5.833 0 0 0-4.201-9.88Zm5.86 10.515a7.5 7.5 0 1 0-1.178 1.178l3.062 3.063a.833.833 0 1 0 1.178-1.178l-3.062-3.063Z",
    clipRule: "evenodd"
  })));
};
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyMCAyMCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjE2NyAzLjMzM2E1LjgzMyA1LjgzMyAwIDEgMCA0LjA0NyAxMC4wMzUuODY2Ljg2NiAwIDAgMSAuMTU0LS4xNTQgNS44MzMgNS44MzMgMCAwIDAtNC4yMDEtOS44OFptNS44NiAxMC41MTVhNy41IDcuNSAwIDEgMC0xLjE3OCAxLjE3OGwzLjA2MiAzLjA2M2EuODMzLjgzMyAwIDEgMCAxLjE3OC0xLjE3OGwtMy4wNjItMy4wNjNaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";